import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNonReferenceProteome = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 32",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("mask", {
			id: "np-n-cutout",
			children: [/* @__PURE__ */ _jsx("rect", {
				width: 26,
				height: 32,
				fill: "white"
			}), /* @__PURE__ */ _jsxs("g", {
				fill: "black",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						x: 5,
						y: 13.5,
						width: 3,
						height: 15.5
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 18,
						y: 13.5,
						width: 3,
						height: 15.5
					}),
					/* @__PURE__ */ _jsx("path", { d: "M5 13.5 L8 13.5 L21 29 L18 29 Z" }),
					/* @__PURE__ */ _jsx("rect", {
						x: 3.5,
						y: 13,
						width: 6,
						height: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 16.5,
						y: 13,
						width: 6,
						height: .9
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 3,
						y: 29,
						width: 7,
						height: 1
					}),
					/* @__PURE__ */ _jsx("rect", {
						x: 16,
						y: 29,
						width: 7,
						height: 1
					})
				]
			})]
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#np-n-cutout)",
			children: /* @__PURE__ */ _jsx("path", { d: "M26 11v21H0V0h15v11h11z" })
		}),
		/* @__PURE__ */ _jsx("path", { d: "M26 9h-9V0l9 9z" })
	]
});
export default SvgNonReferenceProteome;
